import autocompleteService from "../../services/autocompleteService";

const state = {
    countries: []
};

const getters = {
    countries: state => state.countries,
};

const actions = {
    getCountries({commit}) {
        autocompleteService.fetchCountries()
            .then(results => {
                commit('setCountries', results)
            })
            .catch(error => {
                console.log(error)
            })
    },
};

const mutations = {
    setCountries(state, results) {
        state.countries = results['items'].map(function (e) {
            return e['common_name']
        }).filter(function (e) {
            return e !== 'RESERVED'
        })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}